<template>
  <app-modal modal-id="frund-modal"
             modal-size="default"
             modal-alignment="top"
             @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title">
        {{ selectedUrl ? $t("edit_frund") : $t("add_frund") }}
      </h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form ref="form" v-if="dataLoaded" :data-url="selectedUrl ? selectedUrl : `crm/frunds`">
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("title") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="text"
                  :placeholder="$t('enter_title')"
                  name="name"
                  v-model="formData.name"
                  :error-message="$errorMessage(errors, 'name')"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("lead_group") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="search-select"
                  list-value-field="name"
                  :list="contactTypeList"
                  :placeholder="$t('choose_an_lead_group')"
                  v-model="formData.contact_type_id"
                  :error-message="$errorMessage(errors, 'contact_type_id')"
              />
            </div>
          </div>
        </div>






        

        <template v-if="customFields.length && customFieldDataLoaded">
          <h6 class="pb-3 pt-3">{{ $t("custom_fields") }}</h6>
          <div class="form-group" v-for="field in customFields">
            <div class="row">
              <div class="mb-0 col-sm-5 d-flex align-items-center">
                <label>{{ field.name }}</label>
              </div>
              <div class="col-md-7">
                <template v-if="field.custom_field_type.name === 'text'">
                  <app-input
                    type="text"
                    :id="field.name"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'textarea'">
                  <app-input
                    type="textarea"
                    :id="field.name"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'radio'">
                  <app-input
                    type="radio"
                    :radio-checkbox-name="field.name"
                    :list="generateInputList(field)"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'checkbox'">
                  <app-input
                    type="checkbox"
                    :radio-checkbox-name="field.name"
                    :list="generateInputList(field)"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'select'">
                  <app-input
                    type="select"
                    :list="generateInputList(field)"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'number'">
                  <app-input
                    type="number"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'date'">
                  <app-input type="date" v-model="customFieldValue[field.name]"/>
                </template>
              </div>
            </div>
          </div>
        </template>
      </form>
      <app-overlay-loader v-else/>
    </template>
    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button type="button" class="btn btn-primary" @click.prevent="submit">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
import {getAllCustomFields} from "@app/Mixins/Global/CustomFieldMixin";
import {mapGetters} from "vuex";

export default {
  name: "FrundModal",
  mixins: [FormSubmitMixin, getAllCustomFields],
  data() {
    return {
      isOrganizationModalActive: false,
      addMoreDetails: false,
      dataLoaded: false,
      countryList: [],
      formData: {owner_id: user.id},
      addEditData: {},
      customFieldValue:[],
	  CondList: [
	  		 	{ id: "1", name: "1",},
				{ id: "2", name: "2",},
				{ id: "3", name: "3",},
				{ id: "4", name: "4",},
				{ id: "5", name: "5",},
				{ id: "6", name: "6",},
				{ id: "7", name: "7",},
				{ id: "8", name: "8",},
				{ id: "9", name: "9",},
				{ id: "10", name: "10",},

	  		],
		OwList: [
	  		 	{ id: "1", name: "Собственник",},
				{ id: "2", name: "Аренда",},

	  		],
      organizations: [
        {
          pivot: {
            job_title: "",
            organization_id: "",
          },
        },
      ],
      phone: [
        {
          value: "",
          type_id: "",
        },
      ],
      emails: [
        {
          value: "",
          type_id: "",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      ownerList: "getOwner",
      organizationList: "getOrganization",
      phoneEmailTypeList: "phoneEmailType",
      contactTypeList: "contentType",
    }),

  },
  methods: {
    addMore(){
      this.addMoreDetails = true;
    },
    phoneAdd(index) {
      this.phone.push({value: "", type_id: ""});
    },
    phoneRemove(index) {
      this.phone.splice(index, 1);
    },
    OrgAndJobAdd(index) {
      this.organizations.push({
        pivot: {
          job_title: "",
          organization_id: "",
        },
      });
    },
    OrgAndJobRemove(index) {
      this.organizations.splice(index, 1);
    },
    emailAdd(index) {
      this.emails.push({value: "", type_id: ""});
    },
    emailRemove(index) {
      this.emails.splice(index, 1);
    },
    beforeSubmit() {
      this.loading = true;
    },
    submit() {
      let customData = []
      this.customFields.map((el) => {
        if (this.customFieldValue[el.name]) {
          let item = {
            value:
                el.custom_field_type.name == "checkbox"
                    ? el.meta.split(",").filter((e, i) => {
                      if (
                          this.customFieldValue[el.name].includes(String(i)) ||
                          this.customFieldValue[el.name].includes(i)
                      ) {
                        return e;
                      }
                    })
                    : el.custom_field_type.name == "select" ||
                    el.custom_field_type.name == "radio"
                    ? el.meta.split(",").find((e, i) => {
                      return i == Number(this.customFieldValue[el.name]);
                    })
                    : this.customFieldValue[el.name],
            custom_field_id: el.id,
          };
          customData.push(item);
        }
      });

      this.addEditData.customs = customData;

      this.addEditData.phone = this.phone.map((v, i) => {
        return {
          value: v.value,
          type_id: v.type_id,
        };
      });
      this.addEditData.email = this.emails.map((v, i) => {
        return {
          value: v.value,
          type_id: v.type_id,
        };
      });


      this.addEditData.name = this.formData.name;
		
	  this.addEditData.cond = this.formData.cond;
	  this.addEditData.year_on = this.formData.year_on;
	  this.addEditData.year_off = this.formData.year_off;
	  this.addEditData.material = this.formData.material;
		this.addEditData.designer = this.formData.designer;
		this.addEditData.country_made = this.formData.country_made;
		this.addEditData.country_buy = this.formData.country_buy;
		this.addEditData.date_buy = this.formData.date_buy ? moment(this.formData.date_buy).format(
        "YYYY-MM-DD"
      ) : null;
		this.addEditData.type_owners = this.formData.type_owners;
		this.addEditData.size = this.formData.size;
		this.addEditData.price_s = this.formData.price_s;
		
		
      this.addEditData.contact_type_id = this.formData.contact_type_id;
      this.addEditData.owner_id = this.formData.owner_id;
      this.addEditData.country_id = this.formData.country_id;
      this.addEditData.address = this.formData.address;
      this.addEditData.area = this.formData.area;
      this.addEditData.city = this.formData.city;
      this.addEditData.state = this.formData.state;
      this.addEditData.zip_code = this.formData.zip_code;
      this.addEditData.organizationData = this.organizations.map((v, i) => {
        return {
          job_title: v.pivot.job_title,
          organization_id: v.pivot.organization_id,
        };
      });
      this.save(this.addEditData);
    },
    afterSuccessFromGetEditData(response) {
      this.formData = response.data;
      if (this.formData.country ||
        this.formData.area ||
        this.formData.city ||
        this.formData.state ||
        this.formData.zip_code ||
        this.formData.address){
        this.addAddressDetails = true;
      }
      if (this.formData.phone.length) {
        this.phone = this.formData.phone;
      }
      if (this.formData.email.length) {
        this.emails = this.formData.email;
      }
      if (this.formData.organizations.length) {
        this.organizations = this.formData.organizations;
      }
    },
    openModal() {
      this.$emit("openOrgModal");
    },
    getCountry(){
      this.axiosGet("crm/country").then((res) => {
        this.countryList = res.data;
      });
    }
  },
  mounted() {
    this.getCountry();
    this.$store.dispatch("phoneEmailType");
    this.$store.dispatch("getOwner");
    this.$store.dispatch("getOrganization");
    this.$store.dispatch("contentType");
    this.getAllCustomFields("frund");
    $("#organization-modal").on("hidden.bs.modal", () => {
      this.isOrganizationModalActive = false;
    });
  },
};
</script>
